import { render, staticRenderFns } from "./TopicSection.vue?vue&type=template&id=5d95365b&scoped=true&"
import script from "./TopicSection.vue?vue&type=script&lang=js&"
export * from "./TopicSection.vue?vue&type=script&lang=js&"
import style0 from "./TopicSection.vue?vue&type=style&index=0&id=5d95365b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d95365b",
  null
  
)

export default component.exports